import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { AdminUsersList } from "../types";
import axiosClient from "../utils/axiosClient";
import qs from "query-string";

export const useAdminAllUsers = (
  pageTable: number,
  resultsPerPage: number = 20,
  searchTerm?: string
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, AdminUsersList>(
    ["adminUserList", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
        searchTerm,
      };
      if (!searchTerm) {
        delete query.searchTerm;
      }
      
      const data = await axiosClient.get<AdminUsersList>(`/admin/users?${qs.stringify(query)}`)
      return data.data;
    },
    {
      staleTime: Infinity,
      keepPreviousData: true,
    }
  );
};
